import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-screen-resolution',
  templateUrl: './screen-resolution.component.html',
  styleUrls: ['./screen-resolution.component.scss']
})
export class ScreenResolutionComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
